import React from 'react';
import './App.css';
import { routes } from './routes';
import { IRoute } from './routes/interfaces/route.interface';
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import PrivateRoute from './routes/components/PrivateRoute';

function App() {
  return (
    <Router>
      <Switch>
        {
          routes.map(({ exact, path, privateRoute = false, redirect = null, component } : IRoute, index:number) => {
            if (!!redirect) return <Redirect exact={exact} key={index} from={path} to={redirect} />;
            else if (privateRoute) return <PrivateRoute key={index} exact={exact} path={path} component={component} />
            return <Route key={index} exact={exact} path={path} component={component} />
          })
        }
        <Redirect to="/" />
      </Switch>
    </Router>
  );
}

export default App;
